export const startSessionRecording = (): void => {
  // Only record production, and only 1% of events
  const random = Math.random()
  if (
    process.env.NODE_ENV === 'production' &&
    random < 0.01 &&
    window.mixpanel
  ) {
    try {
      window.mixpanel.start_session_recording()
    } catch (error) {
      console.error('Error starting Mixpanel session recording', error)
    }
  }
}

export const stopSessionRecording = (): void => {
  if (window.mixpanel) {
    try {
      window.mixpanel.stop_session_recording()
    } catch (error) {
      console.error('Error stopping Mixpanel session recording', error)
    }
  }
}
